/*
  DashboardRequest.js - HomeRequest Networking File

  Contains networking functionality for Dashboard Components
*/

// MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const useDashboardRequest = () => {
  const getAnnouncements = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/announcement`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getMessageBalance = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/balance`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getUserSMSTraffic = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/user/smstraffic`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getUserTopError = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/user/toperror`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getCustomerSMSTraffic = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/customer/smstraffic`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getCustomerTopError = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/customer/toperror`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getCustomerTopFiveUsers = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/customer/topfive`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getCustomerLastInvoices = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/customer/lastthree`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getCustomerCampaigns = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/customer/campaigns`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getMessageFailedDeliveryRoutes = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/god-admin/route-failure`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getMessageDeliveryRates = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/god-admin/delivery-rate`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getErrorsByCode = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/god-admin/error-code`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getMessageLatencyAverage = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/god-admin/latency-report`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  const getErrorsByTopCustomers = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/dashboard/god-admin/customer-error`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  // Export functions as a module
  return {
    getAnnouncements,
    getMessageBalance,
    getUserSMSTraffic,
    getUserTopError,
    getCustomerSMSTraffic,
    getCustomerTopError,
    getCustomerTopFiveUsers,
    getCustomerLastInvoices,
    getCustomerCampaigns,
    getMessageFailedDeliveryRoutes,
    getMessageDeliveryRates,
    getErrorsByCode,
    getMessageLatencyAverage,
    getErrorsByTopCustomers,
  };
};
export default useDashboardRequest;
